import {createStore} from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import {State, Stockist} from '/src/vue/stores/stockists.d.ts';

export default function init() {
  return createStore<State>({
    plugins: [createPersistedState({
      key: 'vuex-stockists',
      paths: [
        'stockists',
      ],
    })],
    state: {
      stockists: null,
      filteredStockists: null,
      query: null,
      map: {
        center: {
          lat: 53.817760083069224,
          lng: -3.9649073382636324,
        },
        zoom: 6,
      },
      markers: null,
      radius: null,
    },
    getters: {
      stockists: (state) => state.stockists,
      filteredStockists: (state) => state.filteredStockists,
      map: (state) => state.map,
      query: (state) => state.query,
      radius: (state) => state.radius,
      markers: (state) => state.markers,
    },
    mutations: {
      setStockists(state: State, stockists: Array<Stockist>) {
        state.stockists = [...stockists.filter((stockist: Stockist) => {
          const { latitude, longitude } = stockist.coordinates;
          // Skip stockist if it has no coordinates
          return !(!latitude || !longitude);
        })];
      },
      setFilteredStockists(state: State, value: Array<Stockist>|null) {
        state.filteredStockists = value;
        this.commit('setMapMarkers');
      },
      setMapMarkers(state: State) {
        let { stockists } = state;
        const { filteredStockists } = state;
        stockists = filteredStockists ?? stockists;

        if (!stockists) {
          return;
        }

        state.markers = stockists.map((stockist: Stockist) => {
          const { latitude, longitude } = stockist.coordinates;
          // Skip stockist if it has no coordinates
          if (!latitude || !longitude) {
            return false;
          }
          const position = {
            lat: latitude,
            lng: longitude,
          };
          return {
            id: stockist.id,
            position,
          };
        });
      },
      setMapCenter(state: State, id: number) {
        const { markers } = state;
        if (markers) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const marker = markers.filter((item: any) => item.id === id)[0];
          if (marker) {
            state.map.center = marker.position;
          }
        }
      },
      setMapCenterCoordinates(state: State, coordinates) {
        state.map.center = coordinates;
      },
      setMapZoom(state: State, zoom: number) {
        state.map.zoom = zoom;
      },
      setQuery(state: State, value: string) {
        state.query = value;
      },
      setRadius(state: State, value: number|null) {
        state.radius = value;
      }
    },
    actions: {
      async getStockists({ commit }) {
        try {
          const res = await fetch('/stockists.json');
          const json = await res.json();
          commit('setStockists', json.items);
          commit('setMapMarkers');
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      },
    },
  });
}
